// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactFeather from "react-feather";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Utils$Coronate from "./Utils.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import VisuallyHidden from "@reach/visually-hidden";

function reducer(param, newState) {
  return newState;
}

function useBool(init) {
  var match = React.useReducer(reducer, init);
  var setState = match[1];
  return {
          state: match[0],
          setTrue: (function () {
              setState(true);
            }),
          setFalse: (function () {
              setState(false);
            })
        };
}

function sortedTableReducer(state, action) {
  var newState;
  if (typeof action !== "object") {
    newState = state;
  } else {
    switch (action.TAG) {
      case "SetIsDescending" :
          newState = {
            isDescending: action._0,
            column: state.column,
            table: state.table
          };
          break;
      case "SetColumn" :
          newState = {
            isDescending: state.isDescending,
            column: action._0,
            table: state.table
          };
          break;
      case "SetTable" :
          newState = {
            isDescending: state.isDescending,
            column: state.column,
            table: action._0
          };
          break;
      
    }
  }
  var direction = newState.isDescending ? Utils$Coronate.descend : Utils$Coronate.ascend;
  var f = newState.column;
  var sortFunc;
  switch (f.TAG) {
    case "GetString" :
        var f$1 = f._0;
        sortFunc = (function (extra, extra$1) {
            return Curry._4(direction, Caml.string_compare, (function (str) {
                          return f$1(str).toLowerCase();
                        }), extra, extra$1);
          });
        break;
    case "GetInt" :
        var f$2 = f._0;
        sortFunc = (function (extra, extra$1) {
            return Curry._4(direction, Caml.int_compare, f$2, extra, extra$1);
          });
        break;
    case "GetFloat" :
        var f$3 = f._0;
        sortFunc = (function (extra, extra$1) {
            return Curry._4(direction, Caml.float_compare, f$3, extra, extra$1);
          });
        break;
    case "GetDate" :
        var f$4 = f._0;
        sortFunc = (function (extra, extra$1) {
            return Curry._4(direction, Caml.float_compare, (function (date) {
                          return f$4(date).getTime();
                        }), extra, extra$1);
          });
        break;
    
  }
  var table = Belt_SortArray.stableSortBy(newState.table, sortFunc);
  return {
          isDescending: newState.isDescending,
          column: newState.column,
          table: table
        };
}

function useSortedTable(table, column, isDescending) {
  var initialState = {
    isDescending: isDescending,
    column: column,
    table: table
  };
  var match = React.useReducer(sortedTableReducer, initialState);
  var dispatch = match[1];
  React.useEffect((function () {
          dispatch("SortWithoutUpdating");
        }), []);
  return [
          match[0],
          dispatch
        ];
}

function Hooks$SortButton(props) {
  var dispatch = props.dispatch;
  var data = props.data;
  var sortColumn = props.sortColumn;
  var setKeyOrToggleDir = function () {
    if (data.column === sortColumn) {
      return dispatch({
                  TAG: "SetIsDescending",
                  _0: !data.isDescending
                });
    } else {
      return dispatch({
                  TAG: "SetColumn",
                  _0: sortColumn
                });
    }
  };
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(ReactFeather.ChevronUp, {
                            style: {
                              opacity: "0"
                            }
                          }),
                      "aria-hidden": true
                    }),
                props.children,
                JsxRuntime.jsx("span", {
                      children: data.isDescending ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                JsxRuntime.jsx(ReactFeather.ChevronUp, {}),
                                JsxRuntime.jsx(VisuallyHidden, {
                                      children: "Sort ascending."
                                    })
                              ]
                            }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                JsxRuntime.jsx(ReactFeather.ChevronDown, {}),
                                JsxRuntime.jsx(VisuallyHidden, {
                                      children: "Sort descending."
                                    })
                              ]
                            }),
                      style: {
                        opacity: data.column === sortColumn ? "1" : "0"
                      }
                    })
              ],
              className: "button-micro button-text-ghost title-20",
              style: {
                width: "100%"
              },
              onClick: (function (param) {
                  setKeyOrToggleDir();
                })
            });
}

var SortButton = {
  make: Hooks$SortButton
};

function useLoadingCursorUntil(isLoaded) {
  React.useEffect((function () {
          if (isLoaded) {
            ((document.body.style.cursor = "auto"));
          } else {
            ((document.body.style.cursor = "wait"));
          }
          return (function () {
                    return (document.body.style.cursor = "auto");
                  });
        }), [isLoaded]);
}

export {
  useBool ,
  useSortedTable ,
  SortButton ,
  useLoadingCursorUntil ,
}
/* react Not a pure module */
